/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Practice_Next_QuestionInputs */

const en_interview_practice_next_question = /** @type {(inputs: Interview_Practice_Next_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next Question`)
};

const de_interview_practice_next_question = /** @type {(inputs: Interview_Practice_Next_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nächste Frage`)
};

const fr_interview_practice_next_question = /** @type {(inputs: Interview_Practice_Next_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Question suivante`)
};

const es_interview_practice_next_question = /** @type {(inputs: Interview_Practice_Next_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siguiente pregunta`)
};

const it_interview_practice_next_question = /** @type {(inputs: Interview_Practice_Next_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domanda successiva`)
};

const nl_interview_practice_next_question = /** @type {(inputs: Interview_Practice_Next_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volgende vraag`)
};

const pl_interview_practice_next_question = /** @type {(inputs: Interview_Practice_Next_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Następne pytanie`)
};

const fi_interview_practice_next_question = /** @type {(inputs: Interview_Practice_Next_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seuraava kysymys`)
};

const da_interview_practice_next_question = /** @type {(inputs: Interview_Practice_Next_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Næste spørgsmål`)
};

const sv_interview_practice_next_question = /** @type {(inputs: Interview_Practice_Next_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nästa fråga`)
};

/**
* | output |
* | --- |
* | "Next Question" |
*
* @param {Interview_Practice_Next_QuestionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_practice_next_question = /** @type {((inputs?: Interview_Practice_Next_QuestionInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Practice_Next_QuestionInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_practice_next_question(inputs)
	if (locale === "fr") return fr_interview_practice_next_question(inputs)
	if (locale === "es") return es_interview_practice_next_question(inputs)
	if (locale === "it") return it_interview_practice_next_question(inputs)
	if (locale === "nl") return nl_interview_practice_next_question(inputs)
	if (locale === "pl") return pl_interview_practice_next_question(inputs)
	if (locale === "fi") return fi_interview_practice_next_question(inputs)
	if (locale === "da") return da_interview_practice_next_question(inputs)
	if (locale === "sv") return sv_interview_practice_next_question(inputs)
	return en_interview_practice_next_question(inputs)
});